<template>
  <div class="row">
    <div class="col-4">
      <select class="form-control form-control-sm" @change="selected" v-model="val">
        <option value="EXPORT">Veri Sorumlusundan 3. tarafa veri aktarılıyor</option>
        <option value="IMPORT">3. Taraftan Veri Sorumlusuna veri aktarılıyor</option>
        <option value="BOTH">Her iki tarafa da veri aktarılıyor</option>
        <option value="NONE">Veri aktarılmıyor</option>
      </select>
    </div>
  </div>
</template>

<script>
import AutoCompleteSelect from "./AutoCompleteSelect";
import { methods } from "./commons";

export default {
  props: ["value"],

  components: { AutoCompleteSelect },
  computed: {
    val: {
      get() {
        return this.value ? this.value.value : undefined;
      },
      set(value) {
        this.$emit("input", {
          ...this.value,
          value,
        });
      },
    },
  },
  methods,
};
</script>
